import { render } from "./ValidationHistoryTable.vue?vue&type=template&id=5c3f8364"
import script from "./ValidationHistoryTable.vue?vue&type=script&lang=js"
export * from "./ValidationHistoryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__